import loadable from '@loadable/component';

import { createPlugin } from '@backstage/core-plugin-api';

import {
  METRICS_CHANGE_EXTENSION,
  SEGMENT_CHANGE_EXTENSION,
  createTreatmentsChangeExtension,
  createWorkflowExtension,
} from '@spotify/plugin-confidence-workflows-react';

import { AbTestTableRow } from './components';
import { AbTestIcon } from './components/AbTestIcon';
import { AB_TEST_WORKFLOW_ID } from './constants';
import { REPORT_CHANGE_EXTENSION } from './extensions/ReportChangeExtension';

const TREATMENTS_CHANGE_EXTENSION = createTreatmentsChangeExtension({
  id: 'ab-test-treatments-change',
  fieldPath: '/module_data/abtest',
});

export const confidenceWorkflowsModuleAbTestPlugin = createPlugin({
  id: 'confidence-workflows-module-ab-test',
});

const componentsChunk = () =>
  import(
    /* webpackChunkName: "workflows-ab-test-pages", webpackPrefetch: 5 */ './components'
  );
const loadOptions = {};

const AbTestWorkflowPage = loadable(
  () => componentsChunk().then(m => m.AbTestWorkflowPage),
  loadOptions,
);
const AbTestWorkflowInstancePage = loadable(
  () => componentsChunk().then(m => m.AbTestWorkflowInstancePage),
  loadOptions,
);
const CreateAbTest = loadable(
  () => componentsChunk().then(m => m.CreateAbTest),
  loadOptions,
);
const AbTestOpenGraph = loadable(
  () => componentsChunk().then(m => m.AbTestOpenGraph),
  loadOptions,
);

export const ABTestWorkflowExtension =
  confidenceWorkflowsModuleAbTestPlugin.provide(
    createWorkflowExtension({
      title: 'A/B test',
      workflowId: AB_TEST_WORKFLOW_ID,
      workflowPage: () => <AbTestWorkflowPage />,
      workflowInstancePage: () => <AbTestWorkflowInstancePage />,
      workflowTableRowComponent: AbTestTableRow,
      workflowIcon: AbTestIcon,
      createComponent: overrides => <CreateAbTest overrides={overrides} />,
      openGraphComponent(name) {
        return <AbTestOpenGraph name={name} />;
      },
    }),
  );

// Change extensions

export const TreatmentsChangeExtension =
  confidenceWorkflowsModuleAbTestPlugin.provide(TREATMENTS_CHANGE_EXTENSION);

export const MetricsChangeExtension =
  confidenceWorkflowsModuleAbTestPlugin.provide(METRICS_CHANGE_EXTENSION);

export const ReportChangeExtension =
  confidenceWorkflowsModuleAbTestPlugin.provide(REPORT_CHANGE_EXTENSION);

export const SegmentChangeExtension =
  confidenceWorkflowsModuleAbTestPlugin.provide(SEGMENT_CHANGE_EXTENSION);
